import { useState } from 'react'
import { Drawer, IconButton, iconSizes, Stack, Text, Title, Tooltip } from '@common/ui'
import { IconHistoryToggle } from '@common/ui/icons'
import { com } from '@eidu/web'
import useHasGlobalPermissions from '../permission/useHasGlobalPermissions'
import AuditHistoryTab from './AuditHistoryTab'
import GlobalAction = com.eidu.entity.permission.GlobalAction

type Props = {
  targetId: string
}

const DRAWER_WIDTH = 720

const AuditLogDrawer = ({ targetId }: Props) => {
  const [open, setOpen] = useState(false)
  const { hasPermission, loading } = useHasGlobalPermissions(GlobalAction.ViewAuditLog)
  if (loading || !hasPermission(GlobalAction.ViewAuditLog)) return null

  return (
    <>
      <Tooltip label="Audit log">
        <IconButton onClick={() => setOpen(true)} aria-label="Open audit log" data-testid="audit-log-open">
          <IconHistoryToggle size={iconSizes.sm} stroke={1.5} />
        </IconButton>
      </Tooltip>
      <Drawer
        position="right"
        opened={open}
        onClose={() => setOpen(false)}
        size={DRAWER_WIDTH}
        zIndex={201}
        title={
          <Stack gap={0}>
            <Text size="xs" tt="uppercase" c="dimmed" lh={1}>
              History
            </Text>
            <Title order={4}>Audit log</Title>
          </Stack>
        }
        closeButtonProps={{ 'aria-label': 'Close audit log' }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}>
          <AuditHistoryTab targetId={targetId} />
        </div>
      </Drawer>
    </>
  )
}

export default AuditLogDrawer
